import { Device, DeviceType } from 'lib/types'

export function getNameFromAlertSource(alertSource?: Device) {
  return alertSource?.name
}

export enum VoiceStatus {
  Licensed = 'licensed',
  // A phone gets voice from the license of whoever signs in to it, which the
  // API doesn't record, so the portal can't say whether it has voice.
  ViaUser = 'via_user',
  EssentialOnly = 'essential_only',
}

const isPhone = (device: Device) => device.deviceType === DeviceType.Android || device.deviceType === DeviceType.IOS

export const getVoiceStatus = (device: Device, voiceLicensedIds: Set<string>): VoiceStatus => {
  if (voiceLicensedIds.has(device.id)) return VoiceStatus.Licensed
  if (isPhone(device)) return VoiceStatus.ViaUser
  return VoiceStatus.EssentialOnly
}
